
import React, { useState } from 'react';

interface PortfolioItem {
  id: number;
  title: string;
  location: string;
  beforeImage: string;
  afterImage: string;
  bookingIncrease: string;
  revenueIncrease: string;
}

export const PortfolioSection: React.FC = () => {
  const [selectedItem, setSelectedItem] = useState<number | null>(null);
  const [viewMode, setViewMode] = useState<'before' | 'after'>('before');

  const portfolioItems: PortfolioItem[] = [
    {
      id: 1,
      title: 'Modern Downtown Loft',
      location: 'San Francisco, CA',
      beforeImage: 'https://public.readdy.ai/ai/img_res/ab8ef0e4f571601e02d534621f19bb32.jpg',
      afterImage: 'https://readdy.ai/api/search-image?query=Professional%20bright%20modern%20loft%20interior%2C%20enhanced%20real%20estate%20photography%2C%20perfect%20lighting%2C%20vibrant%20colors%2C%20crystal%20clear%20image%20quality%2C%20luxury%20apartment%20listing%20photo%2C%20AI%20enhanced%20property%20photo%2C%20stunning%20interior%20design&width=400&height=300&seq=portfolio-after-1&orientation=landscape',
      bookingIncrease: '+73%',
      revenueIncrease: '+$1,200/month'
    },
    {
      id: 2,
      title: 'Cozy Beach House',
      location: 'Malibu, CA',
      beforeImage: 'https://readdy.ai/api/search-image?query=Dull%20beach%20house%20interior%20photo%2C%20poor%20lighting%2C%20washed%20out%20colors%2C%20amateur%20vacation%20rental%20photography%2C%20needs%20improvement%2C%20low%20quality%20property%20image%2C%20unprofessional%20real%20estate%20photo&width=400&height=300&seq=portfolio-before-2&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Beautiful%20bright%20beach%20house%20interior%2C%20professional%20vacation%20rental%20photography%2C%20warm%20inviting%20lighting%2C%20enhanced%20colors%2C%20luxury%20coastal%20property%2C%20AI%20enhanced%20real%20estate%20photo%2C%20stunning%20beach%20house%20design&width=400&height=300&seq=portfolio-after-2&orientation=landscape',
      bookingIncrease: '+65%',
      revenueIncrease: '+$950/month'
    },
    {
      id: 3,
      title: 'Urban Studio Apartment',
      location: 'New York, NY',
      beforeImage: 'https://readdy.ai/api/search-image?query=Dark%20cramped%20studio%20apartment%20photo%2C%20poor%20quality%20real%20estate%20image%2C%20dim%20lighting%2C%20unprofessional%20property%20photography%2C%20needs%20enhancement%2C%20low%20resolution%20interior%20shot%2C%20dull%20appearance&width=400&height=300&seq=portfolio-before-3&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Bright%20spacious%20studio%20apartment%2C%20professional%20urban%20property%20photography%2C%20excellent%20lighting%2C%20enhanced%20colors%2C%20modern%20city%20living%20space%2C%20AI%20enhanced%20real%20estate%20photo%2C%20attractive%20rental%20property&width=400&height=300&seq=portfolio-after-3&orientation=landscape',
      bookingIncrease: '+58%',
      revenueIncrease: '+$780/month'
    },
    {
      id: 4,
      title: 'Mountain Cabin Retreat',
      location: 'Aspen, CO',
      beforeImage: 'https://readdy.ai/api/search-image?query=Dark%20rustic%20cabin%20interior%2C%20poor%20quality%20vacation%20rental%20photo%2C%20dim%20lighting%2C%20amateur%20property%20photography%2C%20needs%20improvement%2C%20low%20quality%20mountain%20retreat%20image%2C%20unprofessional%20real%20estate%20photo&width=400&height=300&seq=portfolio-before-4&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Warm%20inviting%20mountain%20cabin%20interior%2C%20professional%20vacation%20rental%20photography%2C%20cozy%20lighting%2C%20enhanced%20wood%20tones%2C%20luxury%20mountain%20retreat%2C%20AI%20enhanced%20property%20photo%2C%20stunning%20rustic%20design&width=400&height=300&seq=portfolio-after-4&orientation=landscape',
      bookingIncrease: '+82%',
      revenueIncrease: '+$1,450/month'
    },
    {
      id: 5,
      title: 'Luxury Penthouse',
      location: 'Miami, FL',
      beforeImage: 'https://readdy.ai/api/search-image?query=Dull%20penthouse%20interior%20photo%2C%20poor%20lighting%2C%20washed%20out%20luxury%20apartment%20image%2C%20amateur%20high-end%20property%20photography%2C%20needs%20enhancement%2C%20low%20quality%20real%20estate%20photo%2C%20unprofessional%20listing%20image&width=400&height=300&seq=portfolio-before-5&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Stunning%20luxury%20penthouse%20interior%2C%20professional%20high-end%20real%20estate%20photography%2C%20perfect%20lighting%2C%20vibrant%20colors%2C%20elegant%20modern%20design%2C%20AI%20enhanced%20property%20photo%2C%20breathtaking%20city%20views&width=400&height=300&seq=portfolio-after-5&orientation=landscape',
      bookingIncrease: '+91%',
      revenueIncrease: '+$2,100/month'
    },
    {
      id: 6,
      title: 'Historic Brownstone',
      location: 'Boston, MA',
      beforeImage: 'https://readdy.ai/api/search-image?query=Dark%20historic%20apartment%20interior%2C%20poor%20quality%20heritage%20property%20photo%2C%20dim%20lighting%2C%20amateur%20real%20estate%20photography%2C%20needs%20improvement%2C%20low%20quality%20brownstone%20image%2C%20unprofessional%20listing%20photo&width=400&height=300&seq=portfolio-before-6&orientation=landscape',
      afterImage: 'https://readdy.ai/api/search-image?query=Beautiful%20historic%20brownstone%20interior%2C%20professional%20heritage%20property%20photography%2C%20warm%20lighting%2C%20enhanced%20architectural%20details%2C%20charming%20period%20features%2C%20AI%20enhanced%20real%20estate%20photo%2C%20elegant%20historic%20home&width=400&height=300&seq=portfolio-after-6&orientation=landscape',
      bookingIncrease: '+67%',
      revenueIncrease: '+$890/month'
    }
  ];

  return (
    <section id="portfolio" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Before & After Showcase</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See the dramatic transformations we've achieved for real Airbnb hosts. 
            These are actual client photos enhanced with our AI technology.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolioItems.map((item) => (
            <div key={item.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative">
                <img
                  src={viewMode === 'before' ? item.beforeImage : item.afterImage}
                  alt={`${item.title} - ${viewMode}`}
                  className="w-full h-48 object-cover"
                />
                
                <div className="absolute top-4 left-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                    viewMode === 'before' 
                      ? 'bg-red-500 text-white' 
                      : 'bg-green-500 text-white'
                  }`}>
                    {viewMode === 'before' ? 'BEFORE' : 'AFTER'}
                  </span>
                </div>
                
                <button
                  onClick={() => setSelectedItem(selectedItem === item.id ? null : item.id)}
                  className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center bg-white/90 rounded-full hover:bg-white transition-colors cursor-pointer"
                >
                  <i className={`ri-${selectedItem === item.id ? 'close' : 'eye'}-line text-gray-700`}></i>
                </button>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600 mb-4 flex items-center">
                  <i className="ri-map-pin-line mr-2"></i>
                  {item.location}
                </p>
                
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div className="text-center">
                    <p className="text-2xl font-bold text-green-600">{item.bookingIncrease}</p>
                    <p className="text-sm text-gray-600">More Bookings</p>
                  </div>
                  <div className="text-center">
                    <p className="text-lg font-bold text-blue-600">{item.revenueIncrease}</p>
                    <p className="text-sm text-gray-600">Revenue Increase</p>
                  </div>
                </div>
                
                {selectedItem === item.id && (
                  <div className="border-t pt-4">
                    <div className="grid grid-cols-2 gap-2">
                      <img
                        src={item.beforeImage}
                        alt={`${item.title} - Before`}
                        className="w-full h-24 object-cover rounded cursor-pointer"
                        onClick={() => setViewMode('before')}
                      />
                      <img
                        src={item.afterImage}
                        alt={`${item.title} - After`}
                        className="w-full h-24 object-cover rounded cursor-pointer"
                        onClick={() => setViewMode('after')}
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-2 mt-2 text-xs text-center">
                      <span className="text-red-600 font-semibold">Before</span>
                      <span className="text-green-600 font-semibold">After</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <div className="flex justify-center gap-4 mb-8">
            <button
              onClick={() => setViewMode('before')}
              className={`px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer ${
                viewMode === 'before'
                  ? 'bg-red-500 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              View All Before Photos
            </button>
            <button
              onClick={() => setViewMode('after')}
              className={`px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer ${
                viewMode === 'after'
                  ? 'bg-green-500 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              View All After Photos
            </button>
          </div>
          
          <div className="bg-blue-50 rounded-lg p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Average Results Across All Projects</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <p className="text-3xl font-bold text-green-600">+71%</p>
                <p className="text-gray-600">Booking Increase</p>
              </div>
              <div className="text-center">
                <p className="text-3xl font-bold text-blue-600">+$1,245</p>
                <p className="text-gray-600">Monthly Revenue</p>
              </div>
              <div className="text-center">
                <p className="text-3xl font-bold text-purple-600">48 hrs</p>
                <p className="text-gray-600">Turnaround Time</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
